// extracted by mini-css-extract-plugin
export default {"box":"O66SCx9ZPVIMpDT7bUQ3","img":"qlKGx_UK9Gb6JfzdmuwB","title":"wrq9smi27uqv9elwaPc_","description":"qTnAKxrKPcj8wsz2Jb9l"};